import request from '@/router/axios'
import env from '@/config/env'

// 获取规则分页
export const rulePage = (params) => {
  return request({
    url: env.ferryUrl + '/im/auto/rule/page',
    method: 'POST',
    data: params
  })
}
// 获取枚举
export const autoEnum = (params) => {
  return request({
    url: env.ferryUrl + '/im/auto/enum',
    method: 'get',
    params
  })
}
// 保存规则
export const autoRuleSave = (params) => {
  return request({
    url: env.ferryUrl + '/im/auto/rule/save',
    method: 'post',
    data: params
  })
}
// 获取规则详情
export const ruleDetail = (params) => {
  return request({
    url: env.ferryUrl + '/im/auto/rule/detail',
    method: 'get',
    params
  })
}
// 改变规则状态
export const changeStatus = (params) => {
  return request({
    url: env.ferryUrl + '/im/auto/rule/changeStatus',
    method: 'put',
    params
  })
}
